import { render, staticRenderFns } from "./bindWechat.vue?vue&type=template&id=d4bbcac6&scoped=true&"
import script from "./bindWechat.vue?vue&type=script&lang=js&"
export * from "./bindWechat.vue?vue&type=script&lang=js&"
import style0 from "./bindWechat.vue?vue&type=style&index=0&id=d4bbcac6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bbcac6",
  null
  
)

export default component.exports